import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { URL_FILES } from "../../../constans/apis";
import { getFileDataUrlFetch } from "../../../lib/files/api/fetchFile";
import withPrefix from "../../../helpers/useQueryPrefix";

/**
 * Descarga la firma de una cotización desde el servicio de archivos y la
 * entrega como data URI, listo para `<img src>` y para `<Image>` de
 * @react-pdf/renderer.
 *
 * Se cachea de forma agresiva: el UUID cambia cada vez que se vuelve a
 * firmar, así que el contenido de un UUID dado es inmutable.
 */
export const useQuoteSignatureImage = (uuidSignature?: string): UseQueryResult<string> => {
  const uuid = uuidSignature?.trim() ?? "";

  return useQuery<string>({
    queryKey: withPrefix(["quotes", "signature", "image", uuid]),
    enabled: uuid.length > 0,
    staleTime: Infinity,
    gcTime: Infinity,
    retry: 1,
    queryFn: () => getFileDataUrlFetch(`${URL_FILES}/${uuid}`, TOKEN_FILES),
  });
};
